<template>
      <div class="user-remark-container">
      <div class="header">
        <span class="text">备注信息</span>
        <span class="add" @click="addRemark">新增备注</span>
      </div>
      <div class="body" v-if="remarksList.length" :style="{height: remarksList.length ? '64px' : 0 }">
        <div class="item" v-for="item in remarksList" :key="item">
          <div class="content">
            <div class="v">{{item.remark}}</div>
            <div class="time-outer">
              <div class="time">{{item.createTime}}</div>
              <div class="edit" @click="editRemark(item)">编辑</div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-else>暂无备注信息</div>
      <div class="loading" v-if="loading">加载中...</div>

      <div class="footer">
        <pagination    
          v-if="remarksList.length"
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :background="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
      </div>
      

      <Dialog :show="showRemarkDialog" :title="form.id ? '编辑备注' : '新增备注'" @submit="submit" @update:show="showRemarkDialog = false" :noAutoCloseDialog="false">
        <div class="remark-form-box">
          <span class="field">备注名:</span>
          <div class="textarea-box">
            <textarea v-model="form.remarkV" rows="5" maxlength="800" @input="updateTextareaHeight" style="resize:none" ></textarea>
            <span class="character-box">{{ form.remarkV.length }}/{{ 800 }}</span>
          </div>
        </div>
      </Dialog>
    </div>
  
</template>

<script lang="ts" setup>
import { queryCustomerRemarkApi, addCustomerRemarkApi, editCustomerRemarkApi } from '@/utils/user';
import { ref, watchEffect } from 'vue';
import Dialog from '@/TUIKit/components/common/Dialog';
import { Toast, TOAST_TYPE } from '@/TUIKit/components/common/Toast';
import pagination from './pagination.vue';

const showRemarkDialog = ref(false)

const props = defineProps<{
  userDetail: any
}>()

const form = ref({
  remarkV: '',
  id: ''
})


const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)


const loading = ref(false);
const remarksList:any = ref([]);

const getRemarkList = async ()=>{
	try {
		loading.value = true;
		const res:any = await queryCustomerRemarkApi({
			"pageNum": currentPage.value,
      "pageSize": pageSize.value,
      "customerId": props.userDetail.id
		})
		remarksList.value = res.body ? res.body.list: [];
    total.value = res?.body?.count || 0;
		console.log(remarksList.value, "popopop");
		
	} catch (err:any) {
		console.log(err);
	}finally{
		loading.value = false;
	} 
}

const handleCurrentChange = (val: number) => {
  currentPage.value = val
  getRemarkList()	
}
const handleSizeChange = (val: number) => {
  pageSize.value = val
  getRemarkList()	
}

const updateTextareaHeight = (event: any)=> {
  event.target.style.height = 'auto'
  event.target.style.height = `${event.target.scrollHeight}px`
}

watchEffect(()=>{
	loading.value = true;
  if(props.userDetail.id){
	  getRemarkList()
  }	
})

const addRemark = ()=>{ 
	showRemarkDialog.value = true;
}
const submit = async ()=>{
  try {
    if(!form.value.remarkV){
      Toast({
        message: '请填写备注信息',
        type: TOAST_TYPE.ERROR,
      });
      return
    }
    if (form.value.id) {
      const res:any = await editCustomerRemarkApi({
        "remark": form.value.remarkV,
        "id": form.value.id,
        "customerId": props.userDetail.id
      })
    } else {
      const res:any = await addCustomerRemarkApi({
        "remark": form.value.remarkV,
        "customerId": props.userDetail.id
      })
    }
		Toast({
      message: form.value.id ? '编辑成功' : '新增成功',
      type: TOAST_TYPE.SUCCESS,
    });

    getRemarkList()
		showRemarkDialog.value = false;
		form.value.remarkV = '';
    form.value.id = '';
	} catch (err:any) {
		console.log(err);
	}
}

const editRemark = (item:any)=>{
  console.log(item, "item");
  showRemarkDialog.value = true;
  form.value.remarkV = item.remark;
  form.value.id = item.id;
}
</script>

<style scoped lang="scss">
.user-remark-container{
  position: relative;
  margin-top: 10px;
  height: 145px;
  border: 1px solid #D9D9D9;
  font-size: 14px;
  .header{
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #D9D9D9;
    .text{
      color: #999; 
    }
   .add{
      color: #0299B5;
      cursor: pointer;
   }
  }
  .body{
    overflow-y: auto;
    .item{
      border-bottom: 1px solid #eee;
      .content{
    
        color: #999;
        padding: 4px 20px;
        .v{}
        .time-outer{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .time{
            margin-top: 10px;
            color: #C8C8C8;
          }
          .edit{
            color: #0299B5;
            cursor: pointer;
          }
        }
      }
    }
    
  }
  .footer{
    margin-top: 2px;
    min-width: 450px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }
  .empty{
    width: 100%;
    font-size: 14px;
    color: #999;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading{
      position: absolute;
      z-index: 2;
      top: 38px;
      height: 100px;
      background-color: rgba(255, 255,255, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
			font-size: 14px;
			color: #999;
		
    }
}


// 弹窗部分
.remark-form-box{
  padding: 20px;
  border: 1px solid #D9D9D9;
  flex: 1;
  display: flex;
  align-items: flex-start;
  width: 501px;

  margin-top: 10px;
  .field{
    margin-right: 20px;
    white-space: nowrap;
  }
  textarea{
    width: 100%;
    border: 1px solid #D9D9D9;
  }
  .textarea-box{
    width: 100%;
    position: relative;
    .character-box{
      position: absolute;
      z-index: 11;
      bottom: 5px;
      right: 5px;
      font-size: 14px;
      color: #C5C5C5
    }
  }
}

/* 自定义滚动条宽度和高度 */
*::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
 
//定义滑块 内阴影+圆角
*::-webkit-scrollbar-thumb {
    border-radius: 1em;
    background-color: rgba(50,50,50,.3);
}
 
//定义滚动条轨道 内阴影+圆角
*::-webkit-scrollbar-track {
    border-radius: 1em;
    background-color: rgba(50,50,50,.1);
}
 
</style>
